// import request from "@/utils/request";
import { post } from "@/utils/request.js"
// 登录
export function login (data) {
    // return request({
    //     url: "/user/login",
    //     method: "post",
    //     data
    // });
    return post("/user/login", data)
}

// 企业注册
export function register (data) {
    return post("/user/company/register", data)
}

// 当前用户获取企业信息
export function userInfo (data) {
    return post("/user/person/findPersonCompanyInfo", data)
}

// 获取当前企业用户的企业信息
export function companyInfo (data) {
    return post("/user/company/findCompanyInfo", data)
}


// 红名单校验
// export function checkInfo (data) {
//     return request({
//         url: "/company/red/findRedNumByName",
//         method: "post",
//         data
//     });
// }
//
// 企业名称校验
export function namecheckInfo (data) {
    return post("/company/red/check", data)
}
// 账号信息更新
export function userUpInfo (data) {
    return post("/user/update", data)
}

// export function getInfo (token) {
//     return request({
//         url: "/vue-element-admin/user/info",
//         method: "get",
//         params: { token }
//     });
// }

// 短信注册
// export function messageInfo (data) {
//     return request({
//         url: "/sqkwry/sendTextMessage",
//         method: "post",
//         data
//     });
// // }
// export function messageInfo (data) {
//     return post("/sqkwry/sendTextMessage", data, true)
// }
// // // 短信注册 校验
// // export function messageCodInfo (data) {
// //     return request({
// //         url: "/sqkwry/selectVerificationByCode",
// //         method: "post",
// //         data
// //     });
// // }
// export function messageCodInfo (data) {
//     return post("/sqkwry/selectVerificationByCode", data, true)
// }
